import React from 'react'

import { useUnit } from 'effector-react'

import { $activeTransferRequests } from 'app/effector/nominees-transfers/request/sipp'

import { Typo } from 'components/_old/Typo'

import Flow from 'components/atoms/Flow/Flow'
import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import { ActiveTransferCard } from '..'

const TransfersInProgress = (): JSX.Element => {
  const [activeTransferRequests] = useUnit([$activeTransferRequests])

  return (
    <React.Fragment>
      <Typography tag="h2" size={24} weight="semibold" lineHeight="small">
        <Typo>Transfers in progress</Typo>
      </Typography>
      <Paper top={24}>
        <Flow space={16}>
          {activeTransferRequests.map((request, index) => {
            return <ActiveTransferCard key={index} request={request} />
          })}
        </Flow>
      </Paper>
    </React.Fragment>
  )
}

export { TransfersInProgress }
